// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { paymentProfileBillingAddressStyles } from "@insite/content-library/Widgets/CheckoutReviewAndSubmit/PaymentProfileBillingAddress";
import { fontConfig } from "@steiner/XDL/PreStyle/typography";
import { css } from "styled-components";

paymentProfileBillingAddressStyles.wrapper = {
    css: css`
        line-height: 18px;
    `,
};

paymentProfileBillingAddressStyles.label = {
    size: fontConfig.fontSize.small,
    weight: fontConfig.weight.semiBold,
    lineHeight: "18px",
    css: css`
        margin-right: 5px;
    `,
};

paymentProfileBillingAddressStyles.text = {
    size: fontConfig.fontSize.small,
    lineHeight: "18px",
};
